import { render, staticRenderFns } from "./CacheManager.vue?vue&type=template&id=0c907124&scoped=true"
import script from "./CacheManager.vue?vue&type=script&lang=js"
export * from "./CacheManager.vue?vue&type=script&lang=js"
import style0 from "./CacheManager.vue?vue&type=style&index=0&id=0c907124&prod&lang=scss&scoped=true"
import style1 from "./CacheManager.vue?vue&type=style&index=1&id=0c907124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c907124",
  null
  
)

export default component.exports